// extracted by mini-css-extract-plugin
export default {"comparison":"_1KEtu","measures":"LYm2V"};